//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#region comment metod

const InsertBankAccount = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertBankAccount,
        method: RequestType.POST,
        data,
    });

const UpdateBankAccount = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateBankAccount,
        method: RequestType.POST,
        data,
    });
const GetCustomerAddress = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerAddress,
        method: RequestType.POST,
        data,
    });
const GetOptHistoryList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetOptHistoryList,
        method: RequestType.POST,
        data,
    });
const GetOptHistoryListV2 = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetOptHistoryListV2,
        method: RequestType.POST,
        data,
    });
const GetCustomerStatusChangeHistoryList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerStatusChangeHistoryList,
        method: RequestType.POST,
        data,
    });
const GetCustomerLastIpAddressByCustomerId = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerLastIpAddressByCustomerId,
        method: RequestType.POST,
        data,
    });
const GetCustomerPhoneVerificationDateByPhoneNumber = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerPhoneVerificationDateByPhoneNumber,
        method: RequestType.POST,
        data,
    });
const GetCustomerOptInByCustomerId = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerOptInByCustomerId,
        method: RequestType.POST,
        data,
    });
const GetCustomerBtPhoneNumber = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerBtPhoneNumber,
        method: RequestType.POST,
        data,
    });
const InsertCustomerRiskStatusChangeHistory = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertCustomerRiskStatusChangeHistory,
        method: RequestType.POST,
        data,
    });
const GetCustomerVerificationDateAndIpAddress = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerVerificationDateAndIpAddress,
        method: RequestType.POST,
        data,
    });
const UpdateCustomerStatus = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCustomerStatus,
        method: RequestType.POST,
        data,
    });
const UpdateCustomerAddress = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCustomerAddress,
        method: RequestType.POST,
        data,
    });
const UpdateCustomer = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCustomer,
        method: RequestType.POST,
        data,
    });
const UpdateCustomerOptIn = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCustomerOptIn,
        method: RequestType.POST,
        data,
    });
const CustomerPhoneNumberChangeEmail = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CustomerPhoneNumberChangeEmail,
        method: RequestType.PUT,
        data,
    });
const GetCustomerBasketInfos = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerBasketInfos,
        method: RequestType.POST,
        data,
    });
const InsertCustomerValidationCode = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.InsertCustomerValidationCode,
        method: RequestType.POST,
        data,
    });
const SendUnmatchedIbanMessage = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SendUnmatchedIbanMessage,
        method: RequestType.POST,
        data,
    });
const DeleteBankAccount = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteBankAccount,
        method: RequestType.POST,
        data,
    });
const CustomerRiskStatusChangeHistoryList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CustomerRiskStatusChangeHistoryList,
        method: RequestType.POST,
        data,
    });
const SendPasswordResetSms = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SendPasswordResetSms,
        method: RequestType.POST,
        data,
    });
const GetCustomerInfoByPhoneOnSSO = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerInfoByPhoneOnSSO,
        method: RequestType.POST,
        data,
    });
const GetCustomerAnonymizedHistory = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerAnonymizedHistory,
        method: RequestType.POST,
        data,
    });
const CustomerAnonymize = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CustomerAnonymize,
        method: RequestType.POST,
        data,
    });
const GetOrderByCustomerId = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetOrderByCustomerId,
        method: RequestType.POST,
        data,
    });
export interface GetRptOrdersRequest {
    customerNo: number;
    subTopicCode: string[];
}

const GetRptOrders = (data: GetRptOrdersRequest): Promise<any> =>
    request({
        url: ApiURL.Command.GetRptOrders,
        method: RequestType.POST,
        data,
    });
const GetCustomerByIdList = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerByIdList,
        method: RequestType.POST,
        data,
    });
const UpdateRptTopic = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateRptTopic,
        method: RequestType.PUT,
        data,
    });
const CreateRptTopic = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.CreateRptTopic,
        method: RequestType.POST,
        data,
    });
const DeleteRptTopic = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.DeleteRptTopic + '/' + data + '/delete',
        method: RequestType.DELETE,
        data,
    });
const GetCustomerCookieApproval = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerCookieApproval,
        method: RequestType.POST,
        data,
    });
const SendCustomerPhoneChangeMail = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.SendCustomerPhoneChangeMail,
        method: RequestType.POST,
        data,
    });
const GetShoppingCarts = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetShoppingCarts,
        method: RequestType.POST,
        data,
    });
const UpdateCustomerEnd = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.UpdateCustomerEnd,
        method: RequestType.POST,
        data,
    });
const ForcePasswordReset = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ForcePasswordReset,
        method: RequestType.POST,
        data,
    });
const IsPhoneNumberUsedBeforeThreeTimes = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.IsPhoneNumberUsedBeforeThreeTimes,
        method: RequestType.POST,
        data,
    });

const ClearCustomerPhoneNumber = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.ClearCustomerPhoneNumber,
        method: RequestType.POST,
        data,
    });

const SendConfirmationCode = (data: { phoneNumber: string; phoneAreaCode: string }): Promise<any> =>
    request({
        url: ApiURL.Command.SendConfirmationCode,
        method: RequestType.POST,
        data,
    });

const GetCustomerDiagnostics = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerDiagnostics,
        method: RequestType.POST,
        data,
    });

const CustomerOrderSummaryList = (data: {
    customerId: number;
    orderListType: number;
    cultureCode: string;
    countryId: number;
    timeFilter?: string | null;
    searchFilter?: string | null;
    take: number;
    skip: number;
}): Promise<any> =>
    request({
        url: ApiURL.Command.CustomerOrderSummaryList,
        method: RequestType.POST,
        data,
    });

const GetCustomerStoreOrderInformation = (data: {
    customerId: number;
    orderNumber: string;
    cultureCode: string;
    platformType: number;
    orderListType: number;
}): Promise<any> =>
    request({
        url: ApiURL.Command.GetCustomerStoreOrderInformation,
        method: RequestType.POST,
        data,
    });

const GetStoreReceipt = (data: {
    orderNumber: string;
    customerId: number;
    countryId: number;
    orderDate: string;
}): Promise<any> =>
    request({
        url: ApiURL.Command.GetStoreReceipt,
        method: RequestType.POST,
        data,
        skipErrorModal: true,
    });

const CustomerCommand = {
    InsertBankAccount,
    UpdateBankAccount,
    GetCustomerAddress,
    GetOptHistoryList,
    GetCustomerStatusChangeHistoryList,
    GetCustomerLastIpAddressByCustomerId,
    GetCustomerPhoneVerificationDateByPhoneNumber,
    GetCustomerOptInByCustomerId,
    GetCustomerBtPhoneNumber,
    InsertCustomerRiskStatusChangeHistory,
    GetCustomerVerificationDateAndIpAddress,
    UpdateCustomerStatus,
    UpdateCustomerAddress,
    UpdateCustomer,
    UpdateCustomerOptIn,
    CustomerPhoneNumberChangeEmail,
    GetCustomerBasketInfos,
    InsertCustomerValidationCode,
    SendUnmatchedIbanMessage,
    DeleteBankAccount,
    CustomerRiskStatusChangeHistoryList,
    SendPasswordResetSms,
    CustomerAnonymize,
    GetCustomerAnonymizedHistory,
    GetCustomerInfoByPhoneOnSSO,
    GetOrderByCustomerId,
    GetRptOrders,
    GetCustomerByIdList,
    UpdateRptTopic,
    CreateRptTopic,
    DeleteRptTopic,
    GetCustomerCookieApproval,
    SendCustomerPhoneChangeMail,
    GetShoppingCarts,
    UpdateCustomerEnd,
    ForcePasswordReset,
    IsPhoneNumberUsedBeforeThreeTimes,
    GetOptHistoryListV2,
    ClearCustomerPhoneNumber,
    SendConfirmationCode,
    GetCustomerDiagnostics,
    CustomerOrderSummaryList,
    GetCustomerStoreOrderInformation,
    GetStoreReceipt,
};

export default CustomerCommand;
